var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import 'isomorphic-fetch';
import 'jquery';
import 'reflect-metadata';
import { PLATFORM } from 'aurelia-framework';
import { HttpClient } from 'aurelia-fetch-client';
import { TokenClient } from './app/services/authentication/token-client.service';
import { RequestConstants } from './app/configuration/request.constants';
import { ConfigurationService } from './app/services/basics/configuration.service';
import { UserClaimsService } from './app/services/authentication/user-claims.service';
import HttpBackend from 'i18next-http-backend';
import moment from 'moment';
import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';
import { BrandingType, TemplateType } from './app/services/modules/brand-client.service';
import { ConfigClientService } from './app/services/modules/client-config.service';
import { RequestClient } from './app/services/basics/request-client.service';
import * as Enumerable from 'linq';
window.dataLayer = window.dataLayer || [];
export function getMainWindow(tokenService) {
    if (tokenService.isAdmin() && !tokenService.isPreview) {
        // if it is admin module
        return 'app/views/app/admin/admin';
    }
    else if (tokenService.isOverlay) {
        // if its form editor of from client
        // if is showing overlay
        return 'app/views/app/client-overlay/client-overlay';
    }
    else if (tokenService.isWidget) {
        // if its form editor of from client
        // if is showing widget
        return 'app/views/app/client-widget/client-widget';
    }
    else if (tokenService.isClient() || tokenService.isPreview) {
        return 'app/views/app/client/client';
    }
    // else return anonymous
    return 'app/views/app/anonymous/anonymous';
}
export function configureInternal(aurelia, requireDev) {
    return __awaiter(this, void 0, void 0, function () {
        var global, server, configurationService, userClaimsService, tokenService, requestClient, configClientService, main, rootMap, lang, resources, fallbackLang, fb;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("app started");
                    global = window;
                    server = global.server;
                    // console.error("server " + JSON.stringify(server));
                    global.lang = server.user.languageCode;
                    aurelia.use.standardConfiguration();
                    console.log('IS_DEV_BUILD: ', server.isDevelopment);
                    if (server.isDevelopment) {
                        aurelia.use.developmentLogging();
                    }
                    new HttpClient().configure(function (config) {
                        var baseUrl = "/";
                        config.withBaseUrl(baseUrl);
                    });
                    configurationService = aurelia.container.get(ConfigurationService);
                    userClaimsService = aurelia.container.get(UserClaimsService);
                    tokenService = aurelia.container.get(TokenClient);
                    requestClient = aurelia.container.get(RequestClient);
                    configClientService = aurelia.container.get(ConfigClientService);
                    tokenService.langs = ['en', 'it', 'pl', 'zh-CN', 'pt', 'da', 'ru'];
                    tokenService.lang = global.lang;
                    tokenService.gameId = server.gameId;
                    tokenService.currentlyLockedByUser = server.currentlyLockedByUser;
                    tokenService.currencies = server.currencies;
                    tokenService.versionNumber = server.version;
                    tokenService.lotteries = server.lotteries;
                    tokenService.isPreview = server.isPreview;
                    tokenService.isOverlay = server.isOverlay;
                    tokenService.isWidget = server.isWidget;
                    tokenService.referer = server.referer;
                    tokenService.kycWinningAmountThreshold = server.kycWinningAmountThreshold;
                    tokenService.setUser(server.user);
                    tokenService.supportUri = server.supportUrl;
                    tokenService.setStorageUri(server.azureStorageUri);
                    tokenService.setIsDevelopment(server.isDevelopment, server.hostname);
                    requestClient.enableLoginDialog = server.user.enableLoginDialog;
                    userClaimsService.setUserClaims(server.user.claims);
                    requestClient.isAdmin = tokenService.isAdmin();
                    requestClient.isPreview = tokenService.isPreview;
                    main = getMainWindow(tokenService);
                    rootMap = {
                        'app/views/app/anonymous/anonymous': PLATFORM.moduleName('app/views/app/anonymous/anonymous'),
                        'app/views/app/client/client': PLATFORM.moduleName('app/views/app/client/client'),
                        'app/views/app/admin/admin': PLATFORM.moduleName('app/views/app/admin/admin'),
                        'app/views/app/client-overlay/client-overlay': PLATFORM.moduleName('app/views/app/client-overlay/client-overlay'),
                        'app/views/app/client-widget/client-widget': PLATFORM.moduleName('app/views/app/client-widget/client-widget'),
                    };
                    if (server && server.xsrfToken) {
                        configurationService.add({
                            key: 'X-XSRF-TOKEN',
                            value: server.xsrfToken,
                            type: RequestConstants.ConfigurationTypes.RequestHeaders
                        });
                    }
                    lang = tokenService.lang;
                    return [4 /*yield*/, requireLocale(lang, tokenService, configClientService)];
                case 1:
                    resources = _a.sent();
                    fallbackLang = "en";
                    if (!(lang !== fallbackLang)) return [3 /*break*/, 3];
                    return [4 /*yield*/, requireLocale(fallbackLang, tokenService, configClientService)];
                case 2:
                    fb = _a.sent();
                    resources[fallbackLang] = fb[fallbackLang];
                    _a.label = 3;
                case 3:
                    // if (lang != fallbackLang) // if not english require english as well as a fallback
                    // {
                    //     resources[fallbackLang] = await requireLocale(fallbackLang, tokenService, configClientService)[fallbackLang];
                    // }
                    if (requireDev)
                        requireDev(tokenService);
                    aurelia.use
                        .globalResources(PLATFORM.moduleName('app/utilities/async-binding'))
                        .globalResources(PLATFORM.moduleName('app/utilities/dirty-binding'))
                        .globalResources(PLATFORM.moduleName('app/utilities/async-dirty-binding'))
                        .globalResources(PLATFORM.moduleName('app/attached-properties/analytics-setter/analytics-setter'))
                        .globalResources(PLATFORM.moduleName('app/views/components/attributes/innerhtml-read-more-less.attribute'))
                        .globalResources(PLATFORM.moduleName('app/views/components/attributes/lookups/lookup-property.attribute'))
                        .globalResources(PLATFORM.moduleName('app/views/components/converters/from-assets'))
                        .globalResources(PLATFORM.moduleName('app/views/components/attributes/validations/validation-property.attribute'))
                        .globalResources(PLATFORM.moduleName('app/attached-properties/async-click-with-loading/async-click-with-loading'))
                        .globalResources(PLATFORM.moduleName('app/attached-properties/animatable-if/animatable-if'))
                        .globalResources(PLATFORM.moduleName('app/converters/ticket-sales-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/numeral-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/currency-jackpot-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/lottery-result-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/number-format'))
                        .globalResources(PLATFORM.moduleName('app/converters/remaining-time-converter'))
                        .globalResources(PLATFORM.moduleName('app/converters/replace-dash-and-capitalize'))
                        .globalResources(PLATFORM.moduleName('app/attached-properties/configurable'))
                        .plugin(PLATFORM.moduleName('oribella-aurelia-sortable'))
                        .plugin(PLATFORM.moduleName('aurelia-ui-virtualization'))
                        .plugin(PLATFORM.moduleName('aurelia-validation'))
                        .plugin(PLATFORM.moduleName('aurelia-i18n'), function (instance) {
                        // register backend plugin
                        instance.i18next.use(HttpBackend);
                        // adapt options to your needs (see http://i18next.com/docs/options/)
                        // make sure to return the promise of the setup method, in order to guarantee proper loading
                        return instance.setup({
                            // backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },  //Add for network loading
                            resources: resources,
                            lng: global.lang,
                            attributes: ['t', 'i18n', 'translate'],
                            fallbackLng: fallbackLang,
                            debug: false
                        });
                    });
                    global.lookups = server.lookups;
                    moment.locale(global.lang);
                    aurelia.start().then(function () {
                        console.log("app loaded " + new Date());
                        console.log("Main:" + main);
                        // return aurelia.setRoot(main);
                        var root = rootMap[main];
                        if (!root) {
                            console.error('Unknown root module:', main);
                            // fallback if you like:
                            return aurelia.setRoot(PLATFORM.moduleName('app/views/app/anonymous/anonymous'));
                        }
                        return aurelia.setRoot(root);
                    });
                    return [2 /*return*/];
            }
        });
    });
}
export function configure(aurelia) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, configureInternal(aurelia, null)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function addPrefix(key, object) {
    var newObject = {};
    for (var innerKey in object) {
        newObject["".concat(key, "-").concat(innerKey)] = object[innerKey];
    }
    return newObject;
}
export function requireText(lang, resources, tokenService, configClientService) {
    return __awaiter(this, void 0, void 0, function () {
        var locales, isClient, lotteryPlatformLocale, _a, jsonAssets, resultItems, resultItems_1, resultItems_1_1, item, key, items, items_1, items_1_1, listItem, listItemKey, defaultItem, lotteryPlatformLocale, _b, jsonAssets, jsonResults, jsonPurchases, jsonCart, jsonOverlay, jsonLobby, jsonLottery, jsonInstantGame, jsonBundle, jsonSyndicate, result, result_1, result_1_1, item, key, items, items_2, items_2_1, listItem, listItemKey, defaultItem, genesisLocal, lotteryPlatformLocal;
        var e_1, _c, e_2, _d, e_3, _e, e_4, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    locales = [];
                    isClient = tokenService.isClient();
                    if (!tokenService.isWidget) return [3 /*break*/, 6];
                    lotteryPlatformLocale = {};
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, configClientService.requireJSONRequest(require("locale/spinola/".concat(lang, ".json")), true)];
                case 2:
                    lotteryPlatformLocale = _g.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _g.sent();
                    console.log("Did not find spinola ".concat(lang, ".json"));
                    return [3 /*break*/, 4];
                case 4:
                    jsonAssets = configClientService.getClientConfig(TemplateType.Assets);
                    return [4 /*yield*/, Promise.all([jsonAssets])];
                case 5:
                    resultItems = _g.sent();
                    // load text - seed with platform locale; theme config entries below override it
                    locales = [lotteryPlatformLocale];
                    try {
                        // load locale
                        for (resultItems_1 = __values(resultItems), resultItems_1_1 = resultItems_1.next(); !resultItems_1_1.done; resultItems_1_1 = resultItems_1.next()) {
                            item = resultItems_1_1.value;
                            if (item == null)
                                continue;
                            for (key in item) {
                                if (Array.isArray(item[key])) { // if is array
                                    items = item[key];
                                    try {
                                        for (items_1 = (e_2 = void 0, __values(items)), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                                            listItem = items_1_1.value;
                                            listItemKey = listItem["key"];
                                            if (key == TemplateType.Ads) // if is ads key add prefix
                                                locales.push(addPrefix("".concat(listItemKey, "-link"), listItem[BrandingType.Text][lang]));
                                            else // else its the root key
                                             {
                                                defaultItem = items.filter(function (a) { return a.key == "default"; })[0];
                                                locales.push(addPrefix(listItemKey, defaultItem ? defaultItem[BrandingType.Text][lang] : {}));
                                                // overwrite with current values
                                                locales.push(addPrefix(listItemKey, listItem[BrandingType.Text][lang]));
                                            }
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (items_1_1 && !items_1_1.done && (_d = items_1.return)) _d.call(items_1);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                }
                                else { // if is object
                                    if (key == TemplateType.Ads) // if is ads key add prefix
                                        locales.push(addPrefix("link", item[key][BrandingType.Text][lang]));
                                    else // else its the root key
                                        locales.push(item[key][BrandingType.Text][lang]);
                                }
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (resultItems_1_1 && !resultItems_1_1.done && (_c = resultItems_1.return)) _c.call(resultItems_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return [3 /*break*/, 13];
                case 6:
                    if (!(isClient || tokenService.isPreview || tokenService.isOverlay)) return [3 /*break*/, 12];
                    lotteryPlatformLocale = {};
                    _g.label = 7;
                case 7:
                    _g.trys.push([7, 9, , 10]);
                    return [4 /*yield*/, configClientService.requireJSONRequest(require("locale/spinola/".concat(lang, ".json")), true)];
                case 8:
                    lotteryPlatformLocale = _g.sent();
                    return [3 /*break*/, 10];
                case 9:
                    _b = _g.sent();
                    console.log("Did not find spinola ".concat(lang, ".json"));
                    return [3 /*break*/, 10];
                case 10:
                    jsonAssets = configClientService.getClientConfig(TemplateType.Assets);
                    jsonResults = configClientService.getClientConfig(TemplateType.Results);
                    jsonPurchases = configClientService.getClientConfig(TemplateType.Purchases);
                    jsonCart = configClientService.getClientConfig(TemplateType.Cart);
                    jsonOverlay = configClientService.getClientConfig(TemplateType.Overlay);
                    jsonLobby = configClientService.getClientConfig(TemplateType.Lobby);
                    jsonLottery = configClientService.getClientConfig(TemplateType.Lottery);
                    jsonInstantGame = configClientService.getClientConfig(TemplateType.InstantGame);
                    jsonBundle = configClientService.getClientConfig(TemplateType.Bundle);
                    jsonSyndicate = configClientService.getClientConfig(TemplateType.Syndicate);
                    return [4 /*yield*/, Promise.all([jsonAssets, jsonResults, jsonPurchases, jsonCart, jsonLobby, jsonLottery, jsonInstantGame, jsonBundle, jsonSyndicate, jsonOverlay])];
                case 11:
                    result = _g.sent();
                    // load text
                    locales = [lotteryPlatformLocale];
                    try {
                        // load locale
                        for (result_1 = __values(result), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()) {
                            item = result_1_1.value;
                            if (item == null)
                                continue;
                            for (key in item) {
                                if (Array.isArray(item[key])) { // if is array
                                    items = item[key];
                                    try {
                                        for (items_2 = (e_4 = void 0, __values(items)), items_2_1 = items_2.next(); !items_2_1.done; items_2_1 = items_2.next()) {
                                            listItem = items_2_1.value;
                                            listItemKey = listItem["key"];
                                            if (key == TemplateType.Ads) // if is ads key add prefix
                                                locales.push(addPrefix("".concat(listItemKey, "-link"), listItem[BrandingType.Text][lang]));
                                            else // else its the root key
                                             {
                                                defaultItem = items.filter(function (a) { return a.key == "default"; })[0];
                                                locales.push(addPrefix(listItemKey, defaultItem ? defaultItem[BrandingType.Text][lang] : {}));
                                                // overwrite with current values
                                                locales.push(addPrefix(listItemKey, listItem[BrandingType.Text][lang]));
                                            }
                                        }
                                    }
                                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                    finally {
                                        try {
                                            if (items_2_1 && !items_2_1.done && (_f = items_2.return)) _f.call(items_2);
                                        }
                                        finally { if (e_4) throw e_4.error; }
                                    }
                                }
                                else { // if is object
                                    if (key == TemplateType.Ads) // if is ads key add prefix
                                        locales.push(addPrefix("link", item[key][BrandingType.Text][lang]));
                                    else // else its the root key
                                        locales.push(item[key][BrandingType.Text][lang]);
                                }
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (result_1_1 && !result_1_1.done && (_e = result_1.return)) _e.call(result_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    return [3 /*break*/, 13];
                case 12:
                    genesisLocal = require("locale/genesis/".concat(lang, ".json"));
                    lotteryPlatformLocal = require("locale/spinola/".concat(lang, ".json"));
                    locales = [
                        genesisLocal,
                        lotteryPlatformLocal
                    ];
                    _g.label = 13;
                case 13:
                    // load locales into app
                    locales.filter(function (x) { return JSON.stringify(x) != '{}' && x != undefined; }).forEach(function (locale) {
                        var keys = Object.keys(locale);
                        keys.forEach(function (key) {
                            resources[lang]['translation'][key] = locale[key];
                        });
                    });
                    return [2 /*return*/];
            }
        });
    });
}
export function requireImages(lang, resources, tokenClient, configClientService) {
    return __awaiter(this, void 0, void 0, function () {
        var imageLocales, isClient, jsonAssets, result2, assets, assetColors, result2_1, result2_1_1, item, key, items, items_3, items_3_1, listItem, listItemKey, defaultItem, jsonAssets, jsonResults, jsonPurchases, jsonCart, jsonOverlay, jsonLobby, jsonLottery, jsonInstantGame, jsonBundle, jsonSyndicate, result, jsonConfig, assets, assetColors, lobby, result_2, result_2_1, item, key, items, items_4, items_4_1, listItem, listItemKey, defaultItem;
        var e_5, _a, e_6, _b, e_7, _c, e_8, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    imageLocales = [];
                    isClient = tokenClient.isClient();
                    if (!tokenClient.isWidget) return [3 /*break*/, 2];
                    jsonAssets = configClientService.getClientConfig(TemplateType.Assets);
                    return [4 /*yield*/, Promise.all([jsonAssets])];
                case 1:
                    result2 = _e.sent();
                    assets = Enumerable.from(result2).firstOrDefault(function (x) { return x[TemplateType.Assets]; });
                    if (assets[TemplateType.Assets]) {
                        assetColors = Enumerable.from(assets[TemplateType.Assets])
                            .select(function (x) { return addPrefix(x.key, x[BrandingType.Colors]); }).toArray();
                        imageLocales = assetColors.concat(imageLocales);
                    }
                    try {
                        // load images
                        for (result2_1 = __values(result2), result2_1_1 = result2_1.next(); !result2_1_1.done; result2_1_1 = result2_1.next()) {
                            item = result2_1_1.value;
                            if (item == null)
                                continue;
                            for (key in item) {
                                if (Array.isArray(item[key])) { // if is array
                                    items = item[key];
                                    try {
                                        for (items_3 = (e_6 = void 0, __values(items)), items_3_1 = items_3.next(); !items_3_1.done; items_3_1 = items_3.next()) {
                                            listItem = items_3_1.value;
                                            listItemKey = listItem["key"];
                                            if (key == TemplateType.Ads) // if is ads key add prefix
                                                imageLocales.push(addPrefix("".concat(listItemKey, "-image"), listItem[BrandingType.Images][lang]));
                                            else // else its the root key
                                             {
                                                defaultItem = items.filter(function (a) { return a.key == "default"; })[0];
                                                imageLocales.push(addPrefix(listItemKey, defaultItem ? defaultItem[BrandingType.Images][lang] : {}));
                                                // overwrite with current values
                                                imageLocales.push(addPrefix(listItemKey, listItem[BrandingType.Images][lang]));
                                            }
                                        }
                                    }
                                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                                    finally {
                                        try {
                                            if (items_3_1 && !items_3_1.done && (_b = items_3.return)) _b.call(items_3);
                                        }
                                        finally { if (e_6) throw e_6.error; }
                                    }
                                }
                                else { // if is object
                                    if (key == TemplateType.Ads) // if is ads key add prefix
                                        imageLocales.push(addPrefix("image", item[key][BrandingType.Images][lang]));
                                    else // else its the root key
                                        imageLocales.push(item[key][BrandingType.Images][lang]);
                                }
                            }
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (result2_1_1 && !result2_1_1.done && (_a = result2_1.return)) _a.call(result2_1);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                    return [3 /*break*/, 5];
                case 2:
                    if (!(isClient || tokenClient.isPreview || tokenClient.isOverlay)) return [3 /*break*/, 5];
                    jsonAssets = configClientService.getClientConfig(TemplateType.Assets);
                    jsonResults = configClientService.getClientConfig(TemplateType.Results);
                    jsonPurchases = configClientService.getClientConfig(TemplateType.Purchases);
                    jsonCart = configClientService.getClientConfig(TemplateType.Cart);
                    jsonOverlay = configClientService.getClientConfig(TemplateType.Overlay);
                    jsonLobby = configClientService.getClientConfig(TemplateType.Lobby);
                    jsonLottery = configClientService.getClientConfig(TemplateType.Lottery);
                    jsonInstantGame = configClientService.getClientConfig(TemplateType.InstantGame);
                    jsonBundle = configClientService.getClientConfig(TemplateType.Bundle);
                    jsonSyndicate = configClientService.getClientConfig(TemplateType.Syndicate);
                    return [4 /*yield*/, Promise.all([jsonAssets, jsonLobby, jsonResults, jsonPurchases, jsonCart, jsonLottery, jsonInstantGame, jsonBundle, jsonSyndicate, jsonOverlay])];
                case 3:
                    result = _e.sent();
                    return [4 /*yield*/, configClientService.getClientConfig(TemplateType.Config)];
                case 4:
                    jsonConfig = _e.sent();
                    if (jsonConfig[TemplateType.Config][TemplateType.Ticket][BrandingType.Images][lang])
                        imageLocales.push(jsonConfig[TemplateType.Config][TemplateType.Ticket][BrandingType.Images][lang]);
                    assets = Enumerable.from(result).firstOrDefault(function (x) { return x[TemplateType.Assets]; });
                    if (assets[TemplateType.Assets]) {
                        assetColors = Enumerable.from(assets[TemplateType.Assets])
                            .select(function (x) { return addPrefix(x.key, x[BrandingType.Colors]); }).toArray();
                        imageLocales = assetColors.concat(imageLocales);
                    }
                    lobby = Enumerable.from(result).firstOrDefault(function (x) { return x[TemplateType.Lobby]; });
                    if (lobby[TemplateType.Lobby][BrandingType.Featured])
                        imageLocales.push(lobby[TemplateType.Lobby][BrandingType.Featured]);
                    try {
                        // load images
                        for (result_2 = __values(result), result_2_1 = result_2.next(); !result_2_1.done; result_2_1 = result_2.next()) {
                            item = result_2_1.value;
                            if (item == null)
                                continue;
                            for (key in item) {
                                if (Array.isArray(item[key])) { // if is array
                                    items = item[key];
                                    try {
                                        for (items_4 = (e_8 = void 0, __values(items)), items_4_1 = items_4.next(); !items_4_1.done; items_4_1 = items_4.next()) {
                                            listItem = items_4_1.value;
                                            listItemKey = listItem["key"];
                                            if (key == TemplateType.Ads) // if is ads key add prefix
                                                imageLocales.push(addPrefix("".concat(listItemKey, "-image"), listItem[BrandingType.Images][lang]));
                                            else // else its the root key
                                             {
                                                defaultItem = items.filter(function (a) { return a.key == "default"; })[0];
                                                imageLocales.push(addPrefix(listItemKey, defaultItem ? defaultItem[BrandingType.Images][lang] : {}));
                                                // overwrite with current values
                                                imageLocales.push(addPrefix(listItemKey, listItem[BrandingType.Images][lang]));
                                            }
                                        }
                                    }
                                    catch (e_8_1) { e_8 = { error: e_8_1 }; }
                                    finally {
                                        try {
                                            if (items_4_1 && !items_4_1.done && (_d = items_4.return)) _d.call(items_4);
                                        }
                                        finally { if (e_8) throw e_8.error; }
                                    }
                                }
                                else { // if is object
                                    if (key == TemplateType.Ads) // if is ads key add prefix
                                        imageLocales.push(addPrefix("image", item[key][BrandingType.Images][lang]));
                                    else // else its the root key
                                        imageLocales.push(item[key][BrandingType.Images][lang]);
                                }
                            }
                        }
                    }
                    catch (e_7_1) { e_7 = { error: e_7_1 }; }
                    finally {
                        try {
                            if (result_2_1 && !result_2_1.done && (_c = result_2.return)) _c.call(result_2);
                        }
                        finally { if (e_7) throw e_7.error; }
                    }
                    _e.label = 5;
                case 5:
                    // load images into app
                    imageLocales.forEach(function (locale) {
                        var keys = Object.keys(locale);
                        keys.forEach(function (key) {
                            var value = locale[key];
                            // substring to remove quotes from images
                            if (value && value.startsWith("/attachments/")) {
                                value = value.replace("/attachments/", tokenClient.storageUri + "attachments/");
                            }
                            resources[lang]['translation'][key] = value;
                        });
                    });
                    return [2 /*return*/];
            }
        });
    });
}
export function requireLocale(lang, tokenService, configClientService) {
    return __awaiter(this, void 0, void 0, function () {
        var resources, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    resources = {};
                    resources[lang] = { translation: {} };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, requireImages(lang, resources, tokenService, configClientService)];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _c.sent();
                    console.log('Images Not found');
                    return [3 /*break*/, 4];
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    console.log("get text for lang: " + lang);
                    return [4 /*yield*/, requireText(lang, resources, tokenService, configClientService)];
                case 5:
                    _c.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _b = _c.sent();
                    console.log('Language not found!');
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, resources];
            }
        });
    });
}
